<template>
  <gj-modal
      :visible.sync="modalVisible"
  >
    <template #header>
      索赔模板
      <!-- <span class="input-case-title">{{item.msku}}</span> -->
    </template>
    <template #content>
      <gj-alert type="warning" show-icon style="margin-bottom: 20px" border>
        请在对应店铺/站点的亚马逊卖家后台进行申诉，<span style="color: red">避免关联</span>；<br/>
        申诉地址：登录卖家后台 -> Help->Get support ->Selling on amzon->Or, browse for your issue in the menu->Fulfillent by amazon -> <br/>
        <span style="padding: 0 30px;"></span>Damaged or Inventory Lost in Warehouse ->Investigate Inventory Lost in FBA Warehouse（丢失）或Investigate Inventory Damaged in FBA Warehouse（损坏）
      </gj-alert>
      <el-form
          :model="form"
          label-width="320px"
      >
        <el-form-item
            label="店铺/国家"
        >
          {{item.marketId | optionText(marketOption)}}

        </el-form-item>
        <el-form-item
            label="Contact Reason"
        >
          <gj-input width="600px" v-model="form.contactReason" :readonly="true"></gj-input>
          <gj-button v-copy="form.contactReason" type="primary" style="margin-left: 20px">复制</gj-button>
        </el-form-item>
        <el-form-item
            label="Describe"
            class="claim-textarea"
        >
          <gj-textarea :styles="{width: '600px', height: 'calc(100vh - 455px)'}" v-model="form.describe" :readonly="true"></gj-textarea>
          <gj-button v-copy="form.describe" type="primary" style="margin-left: 20px">复制</gj-button>
          <div>
            <span style="color: #666">建议：</span>
            <span style="color: #444">每个case只索赔一个sku，每天索赔数量不超过10个</span>
          </div>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">关闭</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "@/minxins";
  import {mapGetters} from "vuex";
  export default {
    name: "claim-case-template",
    mixins: [modalMixIn],
    props: {
      item: null,
      claimTemplate: null
    },
    computed: {
      ...mapGetters({
        marketOption: "marketOption",
      }),
    },
    data() {
      return {
        form: {
          contactReason: `Issue with FNSKU ${this.item.fnsku}`,
          describe: `Dear Amazon Seller Support,

After reviewing our FBA inventory we found that following FNSKU which was lost or damaged by Amazon, but has not been reimbursed. Please kindly find as following details. It would be highly appreciated if you could submit an investigation and issue a reimbursement. Thank you in advance for your support.

FNSKU: ${this.item.fnsku}${this.damagedWarehouse()}${this.lostWarehouse()}

Totally：
(=) Item discrepancy and need to be reimbursed: ${this.item.estimateClaimQuantity || 0}


Best regards!`,
        }
      }
    },
    methods: {
      damagedWarehouse() {
        return `

Damaged-warehouse：
Date Period: ${this.item.reportStartTime.replace(' 00:00:00', '')} to ${this.item.reportEndTime.replace(' 00:00:00', '')}
(+) Damaged at Amazon fulfillment center: ${this.item.shouldDamageQuantity || 0}
(-) Already reimbursed items(valid): ${this.item.claimedDamageQuantity || 0}
(=) Item discrepancy and need to be reimbursed: ${this.item.estimateDamageQuantity || 0}`;
      },

      lostWarehouse() {
        return `

Lost-warehouse：
Date Period: ${this.item.reportStartTime.replace(' 00:00:00', '')} to ${this.item.reportEndTime.replace(' 00:00:00', '')}
(+) Amazon misplaced inventory: ${this.item.shouldLostQuantity || 0}
(-) Found inventory &Transfer from holding & Already reimbursed items(valid): ${this.claimTemplate.claimedLostQuantity || 0}
(=) Item discrepancy and need to be reimbursed: ${this.item.estimateLostQuantity || 0}`;
      },
    }
  }
</script>

<style scoped>
  .input-case-title {
    font-size: 12px;
    color: #666;
    margin-left: 12px;
  }
  .claim-textarea {
    margin-bottom: 0;
  }
  .claim-textarea .el-textarea {
    width: 600px;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
